
import { Vue, Component, Prop } from "vue-property-decorator";
import FormDatepicker from "@/components/form/FormDatepickerNew.vue";

@Component({
  components: {
    FormDatepicker,
  }
})
export default class DateFilterContainer extends Vue {
  @Prop([Date, String]) start!: any | null;
  @Prop([Date, String]) end!: any | null;
  @Prop({ type: String, default: undefined }) readonly inputClass?: string;
    @Prop({ type: String, default: "" }) readonly iconStyle!: string;
    @Prop({ type: String, default: "" }) readonly placeholder!: string;

  inputDate: null | String = null;

  handleStartInput(date: any) {
    this.$emit("update:start", date);
  }

  handleEndInput(date: any) {
    this.$emit("update:end", date);
  }

}
